import { NavigationMode } from '@app/common/navigation-mode.';
import { Environment } from '@environments/interface.environment';
import { NewsModeFeaturedNews, NewsModePersonalNews } from '@app/common/news-mode';
import { HideNewsComments } from '@app/common/hide-news-comments';
import { HideNewsLikes } from '@app/common/hide-news-likes';
import { ManagedProperties } from '@app/common/managed-property-config';
import { TrendingResult } from '@app/common/trending-result';
import { PrivacySetting } from '@app/common/privacy-setting';
import { RssFeedAmount } from '@app/common/rss-feed';
import { AuthorizationMode } from '@app/common/authorization-mode';
import { DefaultProtectedResourceScopesMap } from '@app/common/msal-angular-configuration';
import { FilterButtonInfo } from '@app/models/filter-button-info';

// Bool Dev Core Intranet Bleeding edge
export const environment: Environment = {
  production: true,
  name: 'bleedingedge',
  tenantHostUrl: 'https://booldev.sharepoint.com',
  coreWorkplaceSiteUrl: 'https://booldev.sharepoint.com/sites/CoreIntranet',
  authorizationMode: AuthorizationMode.Claims,
  msalConfig: {
    tenant: 'booldev.onmicrosoft.com',
    auth: {
      clientId: '438dea8f-3ad2-41cc-88c3-41c7b953024d',
      authority: 'https://login.microsoftonline.com/booldev.onmicrosoft.com',
    },
    domainHint: 'boolclouddev.se',
    protectedResourceScopeMap: [
      ...DefaultProtectedResourceScopesMap,
      [`/api/`, [`438dea8f-3ad2-41cc-88c3-41c7b953024d/.default`]],
      ['https://booldev.sharepoint.com', ['https://booldev.sharepoint.com/.default']],
    ]
  },
  featureSettings: {
    workplaceName: 'Contoso',
    appInsightsTrackingKey: 'e96e41ef-f697-421d-8375-26458647ffa9',
    navigationMode: NavigationMode.HubSite,
    newsModeFeaturedNews: NewsModeFeaturedNews.GraphFromNewsCenterSite,
    newsModePersonalNews: NewsModePersonalNews.SearchNewsFromAnySiteWithChannelField,
    trendingResult: TrendingResult.Modern,
    newsArchiveLink: 'https://booldev.sharepoint.com/_layouts/15/sharepoint.aspx?v=news',
    sharePointNewsCenterUrl: 'https://booldev.sharepoint.com/_layouts/15/sharepoint.aspx?v=news',
    hideNewsComments: HideNewsComments.HideIfNoComments,
    hideNewsLikes: HideNewsLikes.HideIfNoLikes,
    defaultCreateGroupPrivacySetting: PrivacySetting.Private,
    showNewOrModifiedbadgeOnAppTile: true,
    enableNotificationSubscriptions: true,
    rssFeedConfig: {
      feedLinksAndTagName: [
        {
          FeedLink: 'http://www.mynewsdesk.com/se/rss/source/307/pressrelease',
          TagName: 'BoolBySigma'
        }
      ],
      amountToShowPerLoad: RssFeedAmount.Medium
    },
    managedPropertyConfig: ManagedProperties.DefaultConfig,
    redirectToTeamsByDefault: true,
    enableRequiredReading: true,
    allowMarkAsReadFromReqReadList: true,
    prefixToO365Groups: 'Bool-',
    myColleagueRootTerm: 'fdc4ef06-e425-40ca-8483-57e0e7118a0f',
    enableRightSection: true,
    showBirthdayCalendar: true,
    showRestaurantMenus: true,
    enableProjectSection: true,
    enableProfileCardView: true,
    enableUserExperience: true,
    enableSearchFromCustomDB: true,
    enableIosA2hsBanner: true,
    customerProperties:
      [
        {
          Name: 'Construction Total',
          Value: '',
          FormControlName: 'constructionTotal'
        }

      ],
    auditsEnabled: true,
    showFilterByDepartmentButtons: true,
    newsFilterButtonConfig:
    [
      { Name: 'Hamburg', GUID: 'b92f5680-7b3c-4880-ad3f-ce9bfe9e363f', SortOrder: 1 } as FilterButtonInfo,
    ],
    disableLocalStorage: true,
    showPowerBIComponent: true,
    requireChannelSelectionForPowerBIVisuals: true,
    enableAzureADGroupSync: true,
    enableTeamsNotification: true
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
